module.exports = __webpack_public_path__ + "img/e_scooter_disabled2.bfe32a60.svg";